export const TEST_HEADERS = [
    {
      key: 'skill',
      name: 'Nombre',
    },
  ]
